/* eslint-disable react/button-has-type */
import React from 'react';
import { IC } from './ebookShared';

function Ico({ d, size, cls }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size||16} height={size||16}
      viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className={cls||''}>
      <path d={d} />
    </svg>
  );
}

// ─── Analytics Modal ──────────────────────────────────────────────────────────
export function AnalyticsModal({ onClose, analytics }) {
  const a = analytics || {};
  const totalMin = Math.round((a.totalTimeSpent || 0) / 60);
  const avgScore = Math.round(a.avgScore || 0);
  const predicted = Math.round(a.predictedScore || 0);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
        <div className="flex items-center gap-3 px-6 py-4 border-b border-slate-100 sticky top-0 bg-white rounded-t-2xl">
          <div className="w-10 h-10 bg-indigo-600 rounded-xl flex items-center justify-center">
            <Ico d={IC.chart} size={20} cls="text-white" />
          </div>
          <h3 className="text-lg font-black text-slate-900 flex-1">My Analytics</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-700"><Ico d={IC.x} size={20} /></button>
        </div>
        <div className="p-6 flex flex-col gap-5">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {[
              { label: 'Topics Done',  value: `${a.topicsCompleted||0}/${a.topicsTotal||0}` },
              { label: 'Avg Score',    value: `${avgScore}%` },
              { label: 'Time Spent',   value: `${totalMin}m` },
              { label: 'Streak',       value: `${a.streakDays||0}d` },
            ].map(({ label, value }) => (
              <div key={label} className="rounded-xl bg-slate-50 border border-slate-200 p-3 text-center">
                <p className="text-xs text-slate-400 mb-1">{label}</p>
                <p className="text-xl font-black text-slate-900">{value}</p>
              </div>
            ))}
          </div>
          <div className="rounded-xl border border-indigo-200 bg-indigo-50 p-4">
            <div className="flex items-center gap-2 mb-2">
              <Ico d={IC.sparkle} size={16} cls="text-indigo-600" />
              <p className="text-sm font-bold text-indigo-900">AI Exam Prediction</p>
            </div>
            <p className="text-2xl font-black text-indigo-800">{predicted} / 100</p>
            <p className="text-xs text-indigo-500 mt-1">Based on your current performance.</p>
          </div>
          <button onClick={onClose} className="w-full py-2.5 rounded-xl bg-indigo-600 text-white text-sm font-bold hover:bg-indigo-700">
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Topic Completion Modal ───────────────────────────────────────────────────
export function CompletionModal({ topic, onClose, onNextTopic, onAssessment }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6">
        <div className="text-center mb-5">
          <div className="text-4xl mb-3">🎉</div>
          <h3 className="text-xl font-black text-slate-900">Topic Completed!</h3>
          <p className="text-sm text-slate-500 mt-1">{topic?.chapterTitle} › {topic?.topicTitle}</p>
        </div>
        <div className="flex flex-col gap-2">
          <button onClick={onAssessment}
            className="w-full py-3 rounded-xl bg-indigo-600 text-white font-bold text-sm hover:bg-indigo-700 flex items-center justify-center gap-2">
            <Ico d={IC.mcq} size={16} />Take Assessment
          </button>
          <button onClick={onNextTopic}
            className="w-full py-2.5 rounded-xl border border-slate-300 text-slate-700 font-bold text-sm hover:bg-slate-50 flex items-center justify-center gap-2">
            <Ico d={IC.chevR} size={15} />Next Topic
          </button>
          <button onClick={onClose} className="w-full py-2 text-xs text-slate-400 hover:text-slate-600">Maybe later</button>
        </div>
      </div>
    </div>
  );
}
